import React from "react";
import { ConversationsBubbleType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import { textCase } from "../../../../service/ui/UI";
import AppTheme from "../../../../service/app_config/AppTheme";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { useDispatch } from "react-redux";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import { addModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../../const/ModalKeys";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";

const BubbleDocument: React.FC<ConversationsBubbleType> = ({
  message,
  showDocDate = "",
  fromMedia = false,
  longPressStatus = false,
}) => {
  const dispatch = useDispatch();
  const type: number = ResponsiveDeviceType();

  const messageArr: Array<string> = message.split("|");
  const name: string = messageArr[messageArr.length - 1];

  const handleClick = () => {
    if (!longPressStatus) {
      if (UtilityHelper.isNotEmpty(messageArr[1])) {
        SessionStorage.saveValue(
          StorageKeys.preview_image_document,
          JSON.stringify({
            title: "",
            url: messageArr[1],
          })
        );

        dispatch(
          addModal({
            id:
              type === 3
                ? ModalKeys.preview_image_document
                : ModalKeys.chat_preview_image_document,
            title: AppTranslation.text("preview"),
            screenMobileView: type === 3 ? false : true,
          })
        );
      }
    }
  };

  return (
    <div className="bubble-document">
      <div
        className=" d-flex align-items-center"
        role="button"
        onClick={handleClick}
      >
        <IconCircleFilledIcon
          size={35}
          name="document"
          color={AppTheme.white}
        />
        <div className="ps-2">
          <div
            className={`ellipsis ${
              fromMedia ? "line-1 font-gotham-bold color-theme-label" : "line-2"
            }`}
          >
            {textCase(name)}
          </div>
          {UtilityHelper.isNotEmpty(showDocDate) && (
            <div className=" font-gotham-book font-size-10_12">
              {showDocDate}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BubbleDocument;
